import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Row, Col } from 'antd';
import {
  // SwitchCommon,
  ButtonCommon,
  ErrorMessage,
  PrefixedInput,
  showAlertNotification,
  InputCommon,
  LabelWithRequired,
} from 'components/common';
import { AddDiscountCodeModalProps } from 'types/common';
const { TextArea } = Input;

const AddDiscountCodeModal: React.FC<AddDiscountCodeModalProps> = ({
  isOpen,
  onCancel,
  onSubmit,
  onGenerate,
  form,
  editMode = false,
  discountCodeData = null,
  isSubmitting = false,
}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [codePrefix, setCodePrefix] = useState<string>('');
  const [genCode, setGenCode] = useState<string>('');

  useEffect(() => {
    if (genCode) {
      const prefix = genCode.substring(0, 6);
      setCodePrefix(prefix);
      form.setFieldsValue({ baseUser: { code: genCode } });
    }
    if (discountCodeData?.code) {
      const prefix = discountCodeData.code.substring(0, 6);
      setCodePrefix(prefix);
    }
  }, [discountCodeData?.code, genCode, form]);

  useEffect(() => {
    const fetchCode = async () => {
      if (isOpen && !modalOpened && onGenerate) {
        setModalOpened(true);

        if (!editMode) {
          const code = await onGenerate();
          setGenCode(code);
        }
      }

      if (!isOpen) {
        setModalOpened(false);
      }
    };
    fetchCode();
  }, [isOpen, editMode, onGenerate, modalOpened]);

  useEffect(() => {
    if (isOpen) {
      if (editMode && discountCodeData) {
        console.log('Edit material data:', discountCodeData);
        form.setFieldsValue({
          name: discountCodeData.name,
          code: discountCodeData.code,
          salePrice: discountCodeData.salePrice,
          costPrice: discountCodeData.costPrice,
          quantity: discountCodeData.quantity,
          isActive: discountCodeData.isActive,
          note: discountCodeData.description,
        });
      } else if (!editMode) {
        form.resetFields();
        form.setFieldsValue({});
      }
    }
  }, [isOpen, form, editMode, discountCodeData]);

  const getModalTitle = () => {
    if (editMode) {
      return 'CHỈNH SỬA MÃ GIẢM GIÁ';
    }
    return 'THÊM MÃ GIẢM GIÁ MỚI';
  };

  const getModalDescription = () => {
    if (editMode) {
      return 'Vui lòng chỉnh sửa thông tin của mã giảm giá theo nhu cầu của bạn';
    }
    return 'Vui lòng điền đầy đủ thông tin của mã giảm giá mới';
  };

  const getSubmitButtonText = () => {
    if (editMode) {
      return 'Cập nhật';
    }
    return 'Thêm mới';
  };

  return (
    <Modal
      title={
        <div className='flex flex-col bg-white py-[12px] px-[24px] rounded-lg gap-2'>
          <h2 className='text-[18px] font-bold leading-[24px]'>{getModalTitle()}</h2>
          <p className='text-[14px] leading-[20px] text-[var(--textBlack56)] font-normal'>{getModalDescription()}</p>
        </div>
      }
      open={isOpen}
      // onCancel={onCancel}
      footer={null}
      width={1255}
      centered
      className='staff-modal'
      destroyOnClose
      closeIcon={null}
      styles={{
        wrapper: {
          alignItems: 'center',
          paddingTop: '10vh',
        },
      }}
    >
      <div className='px-[24px] py-[12] mb-[12px]'>
        <Form
          form={form}
          requiredMark={false}
          layout='vertical'
          className='bg-white rounded-lg py-[24px] px-[48px] font-medium text-[14px] leading-[20px]'
        >
          <Row gutter={[24, 0]}>
            <Col span={8}>
              <Form.Item
                label={<LabelWithRequired label='Mã' />}
                name='code'
                rules={[
                  { required: true, message: <ErrorMessage message='Vui lòng nhập mã!' /> },
                  { max: 20, message: <ErrorMessage message='Mã không được vượt quá 20 ký tự!' /> },
                  {
                    pattern: /^[a-zA-Z0-9_]+$/,
                    message: <ErrorMessage message='Mã chỉ được chứa chữ cái, số và dấu gạch dưới!' />,
                  },
                ]}
              >
                <PrefixedInput
                  prefix={codePrefix}
                  maxEditableLength={6}
                  placeholder='Nhập mã'
                  disabled={editMode}
                  className='!text-[14px] !leading-[20px] !h-[38px]'
                  inputProps={{
                    suffix: !editMode && (
                      <span
                        className='text-[var(--primaryColor500)] cursor-pointer'
                        onClick={async (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (onGenerate) {
                            try {
                              const code = await onGenerate();
                              if (code && code.length >= 6) {
                                setCodePrefix(code.substring(0, 6));
                                form.setFieldsValue({ baseUser: { ...form.getFieldsValue().baseUser, code } });
                              }
                            } catch (error) {
                              console.error('Error generating code:', error);
                            }
                          }
                        }}
                      >
                        Generate
                      </span>
                    ),
                    hardSize: 'md2',
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={<LabelWithRequired label='Mã giảm giá' />}
                name={'discountCode'}
                rules={[{ required: true, message: <ErrorMessage message='Vui lòng nhập mã giảm giá!' /> }]}
              >
                <InputCommon placeholder='Nhập mã giảm giá' hardSize='md2' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={<LabelWithRequired label='% Giảm Giá' />}
                name={'discountValue'}
                rules={[{ required: true, message: <ErrorMessage message='Vui lòng nhập % giảm giá!' /> }]}
              >
                <InputCommon placeholder='Nhập % giảm giá' hardSize='md2' type='number' min={0} max={100} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                className='font-normal'
                label='Mô tả'
                name='description'
                rules={[{ max: 1000, message: <ErrorMessage message='Mô tả không được vượt quá 1000 ký tự!' /> }]}
              >
                <TextArea rows={4} placeholder='Nhập vào mô tả...' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <div className='flex justify-center gap-3 mt-6'>
        <ButtonCommon color='none' size='md' radius='rounded' onClick={onCancel} disabled={isSubmitting}>
          Hủy
        </ButtonCommon>
        <ButtonCommon
          color='primary'
          size='md'
          radius='rounded'
          loading={isSubmitting}
          onClick={() => {
            form
              .validateFields()
              .then(onSubmit)
              .catch((errorInfo) => {
                showAlertNotification({
                  type: 'warning',
                  title: 'Thông báo',
                  message: 'Vui lòng nhập đúng thông tin mã giảm giá',
                });
                console.log('Validation failed:', errorInfo);
              });
          }}
        >
          {getSubmitButtonText()}
        </ButtonCommon>
      </div>
    </Modal>
  );
};

export default AddDiscountCodeModal;
